<main id="scrolled">
  <div class="container">
    <h2>{{ 'fnol-request-list.title' | translate }}</h2>
    <div class="search-actions">
      <div class="filter-progress-container">
        <div class="filter-progress" (click)="progressFilterChange(FnolRequestStatusFilter.ALL)"
             [class.active]="progressFilter===FnolRequestStatusFilter.ALL">
          {{ 'fnol-request-list.status-all' | translate }} ({{ countFnolRequestsInProgress(FnolRequestStatusFilter.ALL) }})
        </div>
        <div class="filter-progress" (click)="progressFilterChange(FnolRequestStatusFilter.TODO)"
             [class.active]="progressFilter===FnolRequestStatusFilter.TODO">
          {{ 'fnol-request-list.status-new' | translate }} ({{ countFnolRequestsInProgress(FnolRequestStatusFilter.TODO) }})
        </div>
        <div class="filter-progress" (click)="progressFilterChange(FnolRequestStatusFilter.IN_PROGRESS)"
             [class.active]="progressFilter===FnolRequestStatusFilter.IN_PROGRESS">
          {{ 'fnol-request-list.status-in-progress' | translate }} ({{ countFnolRequestsInProgress(FnolRequestStatusFilter.IN_PROGRESS) }})
        </div>
        <div class="filter-progress" (click)="progressFilterChange(FnolRequestStatusFilter.DONE)"
             [class.active]="progressFilter===FnolRequestStatusFilter.DONE">
          {{ 'fnol-request-list.status-completed' | translate }} ({{ countFnolRequestsInProgress(FnolRequestStatusFilter.DONE) }})
        </div>
      </div>
      <div class="flex-placeholder"></div>
      <div class="labels-container">
        <section>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.SIMPLE_CLAIM)"
                        (change)="toggleLabelInFilter(TasksLabels.SIMPLE_CLAIM)">{{ 'fnol-request-side-bar.labels.simple_claim' | translate }}
          </mat-checkbox>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.MULTIPLE_CLAIMS)"
                        (change)="toggleLabelInFilter(TasksLabels.MULTIPLE_CLAIMS)">{{ 'fnol-request-side-bar.labels.multiple_claims' | translate }}
          </mat-checkbox>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.WAITING)"
                        (change)="toggleLabelInFilter(TasksLabels.WAITING)">{{ 'fnol-request-side-bar.labels.waiting' | translate }}
          </mat-checkbox>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.SIMPEGO)"
                        (change)="toggleLabelInFilter(TasksLabels.SIMPEGO)">{{ 'fnol-request-side-bar.labels.simpego' | translate }}
          </mat-checkbox>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.AGENT)"
                        (change)="toggleLabelInFilter(TasksLabels.AGENT)">{{ 'fnol-request-side-bar.labels.agent' | translate }}
          </mat-checkbox>
          <mat-checkbox [checked]="isLabelFiltered(TasksLabels.POTENTIAL_DUPLICATE)"
                        (change)="toggleLabelInFilter(TasksLabels.POTENTIAL_DUPLICATE)">{{ 'fnol-request-side-bar.labels.potential_duplicate' | translate }}
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="searchForInitialReserveDataNotSet" (change)="toggleInitialReserveDataNotSetInFilter()">{{ 'fnol-request-side-bar.labels.initial-reserve-data-not-set' | translate }}
          </mat-checkbox>
        </section>
      </div>
      <div class="search-actions-button">
        <button (click)="openFindModal()" color="primary"
                mat-raised-button>{{ 'fnol-request-list.button-search' | translate }}
        </button>
        <button (click)="fetchAllFnolRequests(); resetSearch()" color="primary"
          mat-raised-button>{{ 'fnol-request-list.button-fetch-all' | translate }}
        </button>
      </div>
    </div>

    <div class="sort-container">
      <div class="sort-title">{{ 'fnol-request-list.sort-title' | translate }}</div>
      <div (click)="sortBy('prio')" class="sort-item pointer">{{ 'fnol-request-list.sort-priority' | translate }}
        <mat-icon *ngIf="listSort!='+prio' && listSort !='-prio'">height</mat-icon>
        <mat-icon *ngIf="listSort=='+prio'">north</mat-icon>
        <mat-icon *ngIf="listSort=='-prio'">south</mat-icon>
      </div>

    </div>

    <div class="search-results-container">
      <ng-container *ngIf="filteredFnolRequests.length else noResults">
        <CPF-fnol-request-list-item *ngFor="let fnolRequest of filteredFnolRequests" [fnolReuqest]="fnolRequest"></CPF-fnol-request-list-item>

        <div class="load-mode" *ngIf="lastEvaluatedKey && !USE_SCROLL_TO_LOAD">
          <button (click)="loadMoreFnolRequests()" color="primary"
                  mat-raised-button>{{ 'fnol-request-list.button-load-more' | translate }}
          </button>
        </div>
      </ng-container>
      <ng-template #noResults>
        <div class="no-results">
          <p>{{ 'fnol-request-list.no-results' | translate }}</p>
        </div>
        <div class="load-mode" *ngIf="lastEvaluatedKey && !USE_SCROLL_TO_LOAD">
          <button (click)="loadMoreFnolRequests()" color="primary"
                  mat-raised-button>{{ 'fnol-request-list.button-load-more' | translate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</main>
